import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ILogin} from '@core/models';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private baseUrl = `${environment.serverUrl}Usuario/`;
  private baseUrl2 = `${environment.serverUrl}ApiKey/`;


  constructor(private http: HttpClient) {}

  login(user: ILogin) {
    return this.http.post(`${this.baseUrl}login`, user);
  }
  GetEmpresaByWeb(apiKey: string) {
    const headers = { 'ApiKey': apiKey };
    return this.http.get(`${this.baseUrl2}GetEmpresaByWeb`, { headers });
  }

  
}
